<div class="homepage-dashboard">
<div class="sm:hidden mx:block" style="background: white;">
  <customer-select class="customer-selector" style="display: flex; justify-content: end; background: white;
    border-bottom: 1px solid black;"></customer-select>
</div>

  <!-- Section 1: Banner + News（接口剥离，单独渲染，不受看板全页 loading 控制） -->
  <div class="ads-row">
    <!-- Left: Product Banner -->
    <div class="banner-loading" *ngIf="bannerLoading && bannerList.length === 0">
      <div class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="banner-container" *ngIf="bannerList.length > 0">
      <div class="banner-track" [style.transform]="getBannerTrackTransform()">
        <div
          class="banner-slide"
          *ngFor="let banner of bannerList"
          [class.banner-clickable]="banner.navigationUrl"
          (click)="onBannerClick(banner)">
          <div class="banner-image">
            <img [src]="banner.image" [alt]="banner.title" />
          </div>
          <div class="banner-overlay"></div>
        </div>
      </div>
      <div class="banner-dots" *ngIf="bannerList.length > 1">
        <span
          class="banner-dot"
          *ngFor="let banner of bannerList; let i = index"
          [class.active]="i === currentBannerIndex"
          (click)="goToBanner(i)"
        ></span>
      </div>
    </div>

    <!-- Right: News Section -->
    <div class="news-card" *ngIf="newsLoading || permNews">
      <div class="news-header">
        <div class="news-title-row">
          <span class="news-icon">
            <img src="assets/homepage/news.png" alt="" width="20" height="20" />
          </span>
          <span class="news-section-title">{{ 'HOMEPAGE_NEWS_ANNOUNCEMENTS' | translate }}</span>
        </div>
        <!-- <a class="news-more-link">{{ 'HOMEPAGE_ALL_NEWS' | translate }}</a> -->
      </div>
      <div class="news-list">
        <!-- 未拿到数据：展示三个点 loading 状态 -->
        <div class="loading-dots" *ngIf="newsLoading">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <!-- 拿到数据：展示新闻列表 -->
        <ng-container *ngIf="!newsLoading">
          <div class="news-item" *ngFor="let item of newsItems; let first = first" [class.first]="first">
            <div class="news-item-head">
              <span class="news-date">{{ item.date }}</span>
              <!-- 附件下载入口：introductionFile 有值才展示，点击下载 /userCenterAdmin/file/download/{id} -->
              <i
                class="news-attachment-icon"
                *ngIf="item.introductionFile"
                nz-icon
                nzType="paper-clip"
                nzTheme="outline"
                (click)="downloadIntroductionFile(item.introductionFile, item.fileName)"
              ></i>
            </div>
            <div class="news-item-title">{{ item.title }}</div>
            <div class="news-item-desc">{{ item.desc }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- 看板全页 Loading：Banner/News 已剥离单独渲染，此处仅等待 Section 2~5 的接口 -->
  <div class="page-loading" *ngIf="pageLoading">
    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

  <!-- 数据看板 Section 2~5：所有接口返回后统一渲染 -->
  <ng-container *ngIf="!pageLoading">
  <!-- Section 2: 采购目标达成 (1) -->
  <div class="purchase-section" *ngIf="hasPurchaseTarget && hasPurchaseModule">
    <!-- Header Row: dropdown + title + link -->
    <div class="purchase-header">
      <div class="purchase-title-container">
        <span class="purchase-title">{{ 'HOMEPAGE_TARGET_ACHIEVEMENT_YEARLY' | translate }}</span>
      </div>
      <a class="report-link" (click)="goToTargetAchievement()">
        {{ 'HOMEPAGE_VIEW_DETAIL_REPORT' | translate }}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#007BC0" stroke-width="2" stroke-linecap="round"/></svg>
      </a>
    </div>

    <!-- Cards Row -->
    <div class="purchase-cards-row">
      <!-- 订单追踪 Card -->
      <div class="order-tracking-card" *ngIf="permOrder && hasOrderData">
        <div class="card-title-bar">
          <span class="card-title">{{ 'HOMEPAGE_ORDER_TRACKING' | translate }}</span>
          <span class="card-unit">{{ 'HOMEPAGE_UNIT' | translate }}</span>
        </div>
        <!-- Steps (left) paired with order stats (right) -->
        <div class="order-tracking-body">
          <div class="step-track-line" aria-hidden="true"></div>
          <ng-container *ngFor="let stat of orderStats; let i = index">
            <div class="step-circle active">{{ i + 1 }}</div>
            <div class="order-stat-card">
              <div class="stat-icon-wrap" [style.background]="stat.bgColor">
                <img [src]="stat.icon" [alt]="stat.label | translate" />
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ stat.label | translate }}</span>
                <span class="stat-value">{{ stat.value | number }}</span>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="order-total-bar">
          <span class="order-total-text">{{ 'HOMEPAGE_TOTAL_NET_VALUE' | translate }}: {{ orderTotalNetAmount | number }}</span>
        </div>
        <div class="card-timestamp left">{{ 'HOMEPAGE_TIMESTAMP' | translate: { time: orderLatestUpdateTime } }}</div>
      </div>

      <!-- 年度达成 + 产品线 Panel -->
      <div class="annual-card" *ngIf="permAnnual">
        <div class="annual-card-header">
          <span class="annual-card-title">{{ 'HOMEPAGE_ANNUAL_ACHIEVEMENT' | translate }}</span>
          <span class="annual-card-unit">{{ 'HOMEPAGE_UNIT' | translate }}</span>
        </div>
        <div class="progress-labels">
          <span class="progress-label-start">{{ 'HOMEPAGE_ACHIEVEMENT_RATE' | translate }}</span>
        </div>
        <div class="donut-section">
          <percent-ring
            [percent]="achievementPercent"
            [extraPercent]="estimatedExtraPercent"
          ></percent-ring>
          <div class="annual-targets">
            <div class="target-row">
              <span class="target-label">{{ 'HOMEPAGE_PURCHASE_TARGET' | translate }}</span>
              <span class="target-value gray">{{ purchaseTargetDisplay | number }}</span>
            </div>
            <div class="divider-line"></div>
            <div class="target-row">
              <span class="target-label actual">{{ 'HOMEPAGE_ACTUAL_PURCHASE_TURNOVER' | translate }}</span>
              <span class="target-value green">{{ actualPurchaseAmountDisplay | number:'1.0-0' }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="annual-connector-line" [ngStyle]="connectorLineStyle" aria-hidden="true"></div> -->
        <div class="progress-section" *ngIf="estimatedExtraPercent > 0">
          <div class="progress-bar-wrap">
            <div class="progress-track">
              <div class="progress-marker">
                <span class="marker-icon" aria-hidden="true">
                  <img src="assets/homepage/alert.png" alt="" />
                </span>
                <span class="marker-desc">{{ 'HOMEPAGE_GOODS_ISSUED_ESTIMATE' | translate: { status: 'HOMEPAGE_ORDER_STATUS_GOODS_ISSUED' | translate } }}</span>
              </div>
              <div
                class="progress-extra"
              >
                <span class="marker-label">+{{ estimatedExtraPercent }}%</span>
                <div class="progress-fill">
                  <span class="progress-fill-label">{{ 'HOMEPAGE_ACHIEVEMENT_RATE_YOY' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品线达成率 Card -->
      <div class="product-line-panel" *ngIf="permAnnual || permProductLine">
        <!-- 季度采购数据 Card -->
        <div class="quarterly-card" *ngIf="permAnnual">
          <div class="quarterly-header">
            <div class="quarterly-title-row">
              <span class="quarterly-title">{{ 'HOMEPAGE_QUARTERLY_ACHIEVEMENT' | translate }}</span>
            </div>
            <span class="quarterly-unit">{{ 'HOMEPAGE_UNIT' | translate }}</span>
          </div>
          <div class="quarterly-data">
            <div class="q-data-item">
              <span class="q-data-label">{{ 'HOMEPAGE_PURCHASE_TARGET' | translate }}</span>
              <span class="q-data-value gray">{{ quarterlyTargetDisplay | number }}</span>
            </div>
            <div class="q-data-divider"></div>
            <div class="q-data-item">
              <span class="q-data-label">{{ 'HOMEPAGE_PENDING_PURCHASE_AMOUNT' | translate }}</span>
              <span class="q-data-value green">{{ quarterlyPendingDisplay | number:'1.0-0' }}</span>
            </div>
          </div>
        </div>

        <!-- 产品线达成率 Card -->
        <div class="product-line-card" *ngIf="permProductLine">
          <div class="product-line-header">
            <span class="product-line-title">{{ 'HOMEPAGE_CBF_ACHIEVEMENT' | translate }}</span>
            <a class="more-link" (click)="goToTargetAchievement()">
              {{ 'HOMEPAGE_MORE' | translate }}
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#007BC0" stroke-width="2" stroke-linecap="round"/></svg>
            </a>
          </div>
          <div class="product-line-columns">
            <div class="product-line-list">
              <div class="product-line-item" *ngFor="let line of productLines | slice:0:productLineHalf">
                <div class="pl-name-row">
                  <span class="pl-name">{{ line.name }}</span>
                  <span class="pl-percent">{{ line.value }}%</span>
                </div>
                <div class="pl-bar-track">
                  <div class="pl-bar-fill" [style.width.%]="line.value" [style.background]="line.color"></div>
                </div>
              </div>
            </div>
            <div class="product-line-list">
              <div class="product-line-item" *ngFor="let line of productLines | slice:productLineHalf">
                <div class="pl-name-row">
                  <span class="pl-name">{{ line.name }}</span>
                  <span class="pl-percent">{{ line.value }}%</span>
                </div>
                <div class="pl-bar-track">
                  <div class="pl-bar-fill" [style.width.%]="line.value" [style.background]="line.color"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-timestamp right">{{ 'HOMEPAGE_TIMESTAMP' | translate: { time: annualOverviewLatestUpdateTime } }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 4: 本年度采购目标达成 (2) - Wider layout -->
  <div class="purchase-section-2" *ngIf="!hasPurchaseTarget && hasPurchaseModule && (hasOrderData || actualPurchaseAmountDisplay !== 0)">
    <div class="section2-header">
      <span class="purchase-title">{{ 'HOMEPAGE_TARGET_ACHIEVEMENT_YEARLY' | translate }}</span>
      <a class="report-link" (click)="goToTargetAchievement()">
        {{ 'HOMEPAGE_VIEW_DETAIL_REPORT' | translate }}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#007BC0" stroke-width="2" stroke-linecap="round"/></svg>
      </a>
    </div>
    <div class="section2-body">
      <!-- 订单追踪 (narrow) -->
      <div class="order-tracking-card" *ngIf="permOrder && hasOrderData">
        <div class="card-title-bar">
          <span class="card-title">{{ 'HOMEPAGE_ORDER_TRACKING' | translate }}</span>
          <span class="card-unit">{{ 'HOMEPAGE_UNIT' | translate }}</span>
        </div>
        <!-- Steps (left) paired with order stats (right) -->
        <div class="order-tracking-body">
          <div class="step-track-line" aria-hidden="true"></div>
          <ng-container *ngFor="let stat of orderStats; let i = index">
            <div class="step-circle active">{{ i + 1 }}</div>
            <div class="order-stat-card">
              <div class="stat-icon-wrap" [style.background]="stat.bgColor">
                <img [src]="stat.icon" [alt]="stat.label | translate" />
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ stat.label | translate }}</span>
                <span class="stat-value">{{ stat.value | number }}</span>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="order-total-bar">
          <span class="order-total-text">{{ 'HOMEPAGE_TOTAL_NET_VALUE' | translate }}: {{ orderTotalNetAmount | number }}</span>
        </div>
        <div class="card-timestamp left">{{ 'HOMEPAGE_TIMESTAMP' | translate: { time: orderLatestUpdateTime } }}</div>
      </div>

      <!-- 年度+产品线 (wide) -->
      <div class="annual-wide-card" *ngIf="(permAnnual || permProductLine) && actualPurchaseAmountDisplay !== 0">
        <div class="annual-wide-content">
          <div class="annual-stat-block" *ngIf="permAnnual">
            <div class="annual-stat-header">
              <span class="annual-stat-title">{{ 'HOMEPAGE_ACTUAL_PURCHASE_AMOUNT_YEARLY' | translate }}</span>
              <span class="annual-stat-unit">{{ 'HOMEPAGE_UNIT' | translate }}</span>
            </div>
            <span class="annual-stat-num">{{ actualPurchaseAmountDisplay | number }}</span>
            <div class="timestamp-row">{{ 'HOMEPAGE_TIMESTAMP' | translate: { time: annualOverviewLatestUpdateTime } }}</div>
          </div>
          <div class="product-line-panel" *ngIf="permProductLine">
            <div class="product-line-header">
              <span class="product-line-title">{{ 'HOMEPAGE_PRODUCT_LINE_PURCHASE_AMOUNT' | translate }}</span>
              <a class="more-link" (click)="goToTargetAchievement()">{{ 'HOMEPAGE_MORE' | translate }}
                <svg width="8" height="8" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#007BC0" stroke-width="2" stroke-linecap="round"/></svg>
              </a>
            </div>
            <div class="product-amount-grid">
              <div class="product-amount-card" *ngFor="let item of productLineAmounts">
                <span class="pa-name">{{ item.name }}</span>
                <span class="pa-value">{{ item.amount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 3: 快捷卡片行 (返利 + 售出管理 + 售后管理) -->
  <div class="quick-cards-row" *ngIf="stationGroups.length > 0">
    <!-- 返利 Card -->
    <div class="quick-card-bg-wrapper quick-card-bg-wrapper--rebate" *ngIf="permRebate && hasRebateData">
      <div class="rebate-card">
        <div class="card-header-row">
          <span class="card-heading">{{ 'HOMEPAGE_REBATE_OVERVIEW_YEARLY' | translate }}</span>
          <span class="card-unit small">{{ 'HOMEPAGE_UNIT' | translate }}</span>
        </div>
        <div class="rebate-items">
          <div class="rebate-item">
            <div class="rebate-icon-box" style="background:#9E2896">
              <img src="assets/homepage/target.png" [alt]="'HOMEPAGE_TARGET_REBATE_AMOUNT' | translate" />
            </div>
            <div class="rebate-info">
              <span class="rebate-label">{{ 'HOMEPAGE_TARGET_REBATE_AMOUNT' | translate }}</span>
              <span class="rebate-value">{{ rebateData.targetRebateAmount | number:'1.2-2' }}</span>
            </div>
          </div>
          <div class="rebate-item">
            <div class="rebate-icon-box" style="background:#18837E">
              <img src="assets/homepage/used.png" [alt]="'HOMEPAGE_USED_REBATE_AMOUNT' | translate" />
            </div>
            <div class="rebate-info">
              <span class="rebate-label">{{ 'HOMEPAGE_USED_REBATE_AMOUNT' | translate }}</span>
              <span class="rebate-value">{{ rebateData.settledRebateAmount | number:'1.2-2' }}</span>
            </div>
          </div>
          <div class="rebate-item">
            <div class="rebate-icon-box" style="background:#F19F23">
              <img src="assets/homepage/issued.png" [alt]="'HOMEPAGE_ISSUED_REBATE_AMOUNT' | translate" />
            </div>
            <div class="rebate-info">
              <span class="rebate-label">{{ 'HOMEPAGE_ISSUED_REBATE_AMOUNT' | translate }}</span>
              <span class="rebate-value">{{ rebateData.paidRebateAmount | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
        <a class="report-link-bottom" (click)="goToRebateContracts()">
          {{ 'HOMEPAGE_VIEW_DETAIL_REPORT' | translate }}
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#007BC0" stroke-width="2" stroke-linecap="round"/></svg>
        </a>
      </div>
    </div>

    <!-- 售出管理 Card -->
    <div class="quick-card-bg-wrapper quick-card-bg-wrapper--sales">
      <div class="sales-mgmt-card">
        <div class="sales-card-header">
          <div class="sales-header-left">
            <span class="card-heading">{{ 'HOMEPAGE_SELL_OUT' | translate }}</span>
            <span class="sales-subtitle">{{ 'HOMEPAGE_WORKSHOP_ACHIEVEMENT' | translate }}</span>
          </div>
          <a class="view-all-link" (click)="goToWorkShop()">{{ 'HOMEPAGE_VIEW_ALL' | translate }}</a>
        </div>
        <div class="sales-card-body">
          <div class="station-groups">
            <div
              class="station-group"
              *ngFor="let group of stationGroups"
              [class.station-group-wide]="group.wide"
              [class.station-group-extra]="group.extra"
              [style.borderLeftColor]="group.strokeColor"
            >
              <div class="station-group-header" [class.station-group-header-extra]="group.extra">
                <ng-container *ngIf="!group.extra; else extraHeader">
                  <span class="station-label" [style.background]="group.labelBg" [style.color]="group.labelColor">{{ group.label }}</span>
                  <span class="station-target">{{ 'HOMEPAGE_TARGET_LABEL' | translate }} {{ group.target }}/{{ 'HOMEPAGE_STORE_UNIT' | translate }}</span>
                </ng-container>
                <ng-template #extraHeader>
                  <span class="station-label station-label-extra" [style.background]="group.labelBg" [style.color]="group.labelColor">{{ group.label }}</span>
                  <span class="station-target station-target-extra">{{ 'HOMEPAGE_TARGET_LABEL' | translate }} {{ group.target }}/{{ 'HOMEPAGE_STORE_UNIT' | translate }}</span>
                </ng-template>
              </div>
              <div class="station-count-row">
                <span class="station-count">{{ group.current }} / {{ group.total }} </span>
                <span class="station-unit">{{ 'HOMEPAGE_STORE_UNIT' | translate }}</span>
              </div>
              <div class="station-bar-row">
                <div class="station-bar-track">
                  <div class="station-bar-fill" [style.width.%]="group.percent" [style.background]="group.strokeColor"></div>
                </div>
                <span class="station-percent" [style.color]="group.strokeColor">{{ group.percent }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 售后管理 Card -->
    <!-- <div class="quick-card-bg-wrapper quick-card-bg-wrapper--after-sales">
      <div class="after-sales-card">
        <div class="card-heading-row">
          <span class="card-heading">售后管理</span>
        </div>
        <div class="claim-stats-row">
          <div class="claim-stat-box">
            <span class="claim-number blue">04</span>
            <span class="claim-desc">处理中索赔</span>
          </div>
          <div class="claim-stat-box">
            <span class="claim-number purple">12</span>
            <span class="claim-desc">处理中质保</span>
          </div>
        </div>
        <div class="response-time-row">
          <div class="response-time-header">
            <span class="response-label">客户支持平均响应时间</span>
            <span class="response-value">2.4 小时</span>
          </div>
          <div class="response-progress">
            <div class="response-progress-fill"></div>
          </div>
        </div>
        <button class="warranty-btn">新建质保申请</button>
      </div>
    </div> -->
  </div>

  <!-- Section 5: 本年度返利摘要 (wide horizontal) -->
  <div class="rebate-wide-section" *ngIf="permRebate && hasRebateData && stationGroups.length === 0">
    <div class="rebate-wide-header">
      <span class="purchase-title">{{ 'HOMEPAGE_REBATE_OVERVIEW_YEARLY' | translate }}</span>
      <a class="report-link" (click)="goToRebateContracts()">
        {{ 'HOMEPAGE_VIEW_DETAIL_REPORT' | translate }}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#007BC0" stroke-width="2" stroke-linecap="round"/></svg>
      </a>
    </div>
    <div class="rebate-wide-cards">
      <div class="rebate-wide-card">
        <div class="rwc-icon-wrap" style="background:#9E2896;border-radius:8px;">
          <img src="assets/homepage/target.png" [alt]="'HOMEPAGE_TARGET_REBATE_AMOUNT' | translate" />
        </div>
        <div class="rwc-info">
          <span class="rwc-label">{{ 'HOMEPAGE_TARGET_REBATE_AMOUNT' | translate }}</span>
          <span class="rwc-value">{{ rebateData.targetRebateAmount | number:'1.2-2' }}</span>
        </div>
      </div>
      <div class="rebate-wide-card">
        <div class="rwc-icon-wrap" style="background:#18837E;border-radius:8px;">
          <img src="assets/homepage/used.png" [alt]="'HOMEPAGE_USED_REBATE_AMOUNT' | translate" />
        </div>
        <div class="rwc-info">
          <span class="rwc-label">{{ 'HOMEPAGE_USED_REBATE_AMOUNT' | translate }}</span>
          <span class="rwc-value">{{ rebateData.settledRebateAmount | number:'1.2-2' }}</span>
        </div>
      </div>
      <div class="rebate-wide-card">
        <div class="rwc-icon-wrap" style="background:#F19F23;border-radius:8px;">
          <img src="assets/homepage/issued.png" [alt]="'HOMEPAGE_ISSUED_REBATE_AMOUNT' | translate" />
        </div>
        <div class="rwc-info">
          <span class="rwc-label">{{ 'HOMEPAGE_ISSUED_REBATE_AMOUNT' | translate }}</span>
          <span class="rwc-value">{{ rebateData.paidRebateAmount | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>
  </div>
  </ng-container>

  <!-- 产品推荐浮窗 (Figma: 165:742) -->
  <!-- <div
    class="product-recommend-panel"
    *ngIf="showProductRecommend"
    [ngStyle]="productPanelStyle"
    [class.product-recommend-panel--dragging]="isDraggingProductPanel"
  >
    <div class="product-recommend-header" (mousedown)="onProductPanelHeaderMouseDown($event)">
      <div class="product-recommend-title">
        <span class="product-recommend-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white"/>
          </svg>
        </span>
        <span>{{ 'HOMEPAGE_RECOMMENDATION' | translate }}</span>
      </div>
      <button class="product-recommend-close" type="button" aria-label="{{ 'CLOSE' | translate }}" (click)="closeProductRecommend()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 6L18 18M18 6L6 18" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="product-recommend-list">
      <div class="product-recommend-item" *ngFor="let product of recommendedProducts">
        <div class="product-recommend-thumb">
          <img [src]="product.image" [alt]="product.name" />
        </div>
        <div class="product-recommend-info">
          <div class="product-recommend-name-row">
            <span class="product-recommend-name">{{ product.name }}</span>
            <span class="product-recommend-tag" [class]="'product-recommend-tag--' + product.tagType">{{ product.tag }}</span>
          </div>
          <span class="product-recommend-id">{{ product.id }}</span>
          <span class="product-recommend-desc">{{ product.description }}</span>
        </div>
        <button class="product-recommend-cart" type="button" aria-label="{{ 'ADD_TO_CART_MOBILE' | translate }}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.5 17.5H20V18.5H18.5V20H17.5V18.5H16V17.5H17.5V16H18.5V17.5ZM22 18C22 20.2056 20.2056 22 18 22C15.7944 22 14 20.2056 14 18C14 15.7944 15.7944 14 18 14C20.2056 14 22 15.7944 22 18ZM21 18C21 16.3461 19.6542 15 18 15C16.3458 15 15 16.3461 15 18C15 19.6545 16.3458 21 18 21C19.6542 21 21 19.6545 21 18ZM5.5 16H13.4187C13.5751 15.6435 13.7712 15.308 14.0027 15H5.5C5.05633 15 4.66107 14.703 4.53711 14.2718L3.03137 9.25025C3.01056 9.16926 3 9.08521 3 9.00031C3 8.44892 3.44861 8.00031 4 8.00031H17.0644L15.4865 13.6807C15.8518 13.4674 16.2462 13.2992 16.6625 13.1834L18.483 6.62971C18.5402 6.41609 18.7139 6.21778 18.9595 6.08564C19.2462 5.93128 19.5843 5.88874 19.8419 5.97468L21.3419 6.47468L21.6581 5.52595L20.1581 5.02595C19.6402 4.8534 19.015 4.92024 18.4857 5.20503C17.9912 5.47108 17.6472 5.88514 17.5182 6.36646L17.3422 7.00031H4C2.89722 7.00031 2 7.89753 2 9.00031C2 9.17402 2.0224 9.34663 2.06653 9.51331L3.57764 14.5535C3.82245 15.4053 4.61292 16.0003 5.5 16.0003ZM13.2281 19.5H7.93418C7.71127 20.3615 6.92987 21.0003 6 21.0003C4.89722 21.0003 4 20.1031 4 19.0003C4 17.8975 4.89722 17.0003 6 17.0003C6.92987 17.0003 7.71127 17.6391 7.93418 18.5H13.0251C13.0598 18.8818 13.152 19.2666 13.2281 19.5ZM7 19.0003C7 18.4489 6.55139 18.0003 6 18.0003C5.44861 18.0003 5 18.4489 5 19.0003C5 19.5517 5.44861 20.0003 6 20.0003C6.55139 20.0003 7 19.5517 7 19.0003Z" fill="white"/>
          </svg>
        </button>
      </div>
    </div>

    <button class="product-recommend-more" type="button">
      {{ 'HOMEPAGE_VIEW_MORE_PRODUCTS' | translate }}
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div> -->

</div>
